import { apiRequestToken } from '../Utilidades/apiRequest';
import { ConfiguracionProps, EnlacesProps } from '../interfaces/enlacesInterfaces';

export const getEnlacesHome = async () => {
    return apiRequestToken({
        endpoint: 'enlaceshome',
        token: false,
        method: 'GET',
    })
};
export const getEnlaces = async () => {
    return apiRequestToken({
        endpoint: 'enlaces',
        method: 'GET',
    })
};
export const deleteEnlaces = async (id: number) => {
    return apiRequestToken({
        endpoint: `enlaces/${id}`,
        method: 'DELETE',
    })
};
export const getEnlace = async (id: Number) => {
    return apiRequestToken({
        endpoint: `enlaces/${id}`,
        method: 'GET',
    })
};
export const postEnlace = async (enlacesGuardar: EnlacesProps[]) => {
    return apiRequestToken({
        endpoint: 'enlaces/',
        body: enlacesGuardar,
        method: 'POST',
    })
};
export const getConfiguraciones = async () => {
    return apiRequestToken({
        endpoint: 'configuracionesbanner/1',
        token: false,
        method: 'GET',
    })
};
export const postConfiguracion = async (configuracionGuardar: ConfiguracionProps) => {
    return apiRequestToken({
        endpoint: 'configuraciones',
        body: configuracionGuardar,
        method: 'POST',
    })
};